export const UNASSIGNED_KEY = 'UNASSIGNED';

export const TRASH_KEY = 'TRASH';